import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import NavbarBottom from './NavbarBottom';
import no_image_available from '../images/no_image_available.jpg';


function Pengumuman() {
    const [newsList, SetNews] = useState([]);
    const [dataToDisplay, setDataToDisplay] = useState([]);

    const urlImg = `${process.env.REACT_APP_BASEURL}/galeri/`;

    useEffect(() => {
        fetch(`${process.env.REACT_APP_API_ENDPOINT}/pengumuman`)
        .then((res) => {
            return res.json();
        })
        .then((datas) => {
            //console.log(datas);
            SetNews(datas.data);
        });
    }, []);

    const getLang = localStorage.getItem('lang_code');

    return (
        <>
            <NavbarBottom />
            <div className="p-4">
                <section class="dark:text-gray-800">

                    <div class="container max-w-6xl p-6 mx-auto space-y-6 sm:space-y-12">
                        <div class="mb-6 text-left">
                            <h3 class="font-bold text-left" style={{ fontFamily: 'MuseoSansRounded900', fontSize: 24, fontWeight: 'bold' }}>
                                <span class="text-[#0889c1]">
                                    PENGUMUMAN
                                </span>
                            </h3>
                            {/*<p class="text-left mt-4 font-medium text-slate-500">OUR NEWS</p>*/}
                        </div>

                        <div class="grid justify-center grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4">
                            {newsList.map((data_news, indexnews_list) => (
                                <div className='max-w-sm rounded overflow-hidden shadow-lg' key={indexnews_list} style={{ fontFamily: 'MuseoSansRounded200', fontSize: 14 }}>
                                    <Link to={`/detail-pengumuman/${data_news.id}/${data_news.name}`} class="max-w-sm mx-auto group hover:no-underline focus:no-underline dark:bg-gray-50">
                                        {data_news?.file != '' ? 
                                            <img src={urlImg + '' + data_news.file} alt="Berita Image" class="rounded-lg" />
                                            :
                                            <img src={no_image_available} alt="" />
                                        }
                                       
                                        <div class="p-6 space-y-2">


                                            <h3 style={{ fontSize: 14 }}>{data_news.name}</h3>

                                            <span class="text-xs dark:text-gray-600">{data_news.link}</span>
                                            {/*<p style={{ textAlign: 'justify' }}>
                                            <div dangerouslySetInnerHTML={{ __html: data_news.nama }}></div>
                                        </p>*/}
                                        </div>
                                    </Link>
                                </div>
                            ))}
                        </div>
                    </div>
                </section>
            </div>
        </>
    );
}

export default Pengumuman;
